// extracted by mini-css-extract-plugin
module.exports = {"bubble":"_2rPSA","bubbleWrapper":"_3t8Mj","text":"_3M3bG","primary":"pB0Hi","secondary":"_364On"};